export const columnList = [
    {field: 'name', header: 'Name', initialShown: true},
    {
        field: 'description',
        header: 'Description',
        body: rowData => rowData?.description || '-',
        initialShown: true,
    },
    {
        field: 'hospitalName',
        header: 'Hospital Name ',
        body: rowData => rowData?.hospitalName || '-',
        initialShown: true,
    },
    {
        field: 'numberOfParticipants',
        header: 'Number of Pacticipants',
        body: rowData => rowData?.numberOfParticipants || 0,
        initialShown: true,
    },
    {field: 'createdAt', header: 'Created At', initialShown: true},
]
